<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h2 class="fmtit">List of Maps</h2>
<p class="center"><em class="italic">Maps by Edward Alexander</em></p>
<p class="center1"><a href="#/xhtml/08_Fm02#map1">Northside Driving Tour</a></p>
<p class="center1"><a href="#/xhtml/08_Fm02#map2">Southside Driving Tour</a></p>
<p class="center1"><a href="#/xhtml/08_Fm02#map3">Downtown Walking Tour</a></p>
<p class="center1"><span href="#/xhtml/11_Chapter01#map4" title="Link target outside of Sample">Charleston Harbor</span></p>
<p class="center1"><span href="#/xhtml/12_Chapter02#map5" title="Link target outside of Sample">Battle of Sullivan’s Island</span></p>
<p class="center1"><span href="#/xhtml/13_Chapter03#map6" title="Link target outside of Sample">Prevost’s Invasion</span></p>
<p class="center1"><span href="#/xhtml/14_Chapter04#map7" title="Link target outside of Sample">Prevost’s Withdrawal</span></p>
<p class="center1"><span href="#/xhtml/14_Chapter04#map8" title="Link target outside of Sample">Battle of Stono Ferry</span></p>
<p class="center1"><span href="#/xhtml/14_Chapter04#map9" title="Link target outside of Sample">Battle of Savannah</span></p>
<p class="center1"><span href="#/xhtml/15_Chapter05#map10" title="Link target outside of Sample">Clinton’s Invasion</span></p>
<p class="center1"><span href="#/xhtml/16_Chapter06#map11" title="Link target outside of Sample">Siege of Charleston</span></p>
<p class="center2"><em class="italic">Footnotes for the volume are available at</em></p>
<p class="center"><em class="italic"><span class="weblink"><a href="https://emergingrevolutionarywar.org/emerging-revolutionary-war-series/to-the-last-extremity-footnotes/" target="_blank"><span class="underline">https://emergingrevolutionarywar.org/emerging-revolutionary-war-series/to-the-last-extremity-footnotes/</span></a></span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_List.vue?ab5c86e0